/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type OrgEnrichmentResponseSize = typeof OrgEnrichmentResponseSize[keyof typeof OrgEnrichmentResponseSize];


export const OrgEnrichmentResponseSize = {
  '1-10': '1-10',
  '11-50': '11-50',
  '51-200': '51-200',
  '201-500': '201-500',
  '501-1000': '501-1000',
  '1001-5000': '1001-5000',
  '5001-10000': '5001-10000',
  '10000+': '10000+',
} as const;
